import React from 'react';

import BlockBuilder from '@rsc/ui-components/sanity/BlockBuilder';
import { GetInternalLinkFunctionType } from '@rsc/models/GetInternalLinkFunctionType';
import { SanityBlock } from '@rsc/models/gatsby-graphql-types';
import { Alert, AlertDescription } from '@rsc/ui-components/shadcn/Alert';
import { IoMdAlert } from 'react-icons/io';

export type AlertMessageProps = {
  alertMessage: SanityBlock[];
  getInternalLink: GetInternalLinkFunctionType;
};
function AlertMessage({
  alertMessage,
  getInternalLink,
}: Readonly<AlertMessageProps>) {
  return (
    <Alert variant="info">
      <IoMdAlert className="size-4" />
      <AlertDescription>
        <div className="[&>p]:m-0">
          <BlockBuilder
            blocks={alertMessage}
            getInternalLink={getInternalLink}
          />
        </div>
      </AlertDescription>
    </Alert>
  );
}

export default AlertMessage;
